import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	height: 100%;
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: ${(props) => (props.isMobile ? 'flex-start' : 'space-between')};
	height: 100dvh;
	width: 100%;
	background: var(--background-1);
	padding: 3rem;
	overflow: auto;

	@media ${Breakpoints.tablet} {
		width: 100%;
		display: ${(props) => (props.isSlideShow ? 'none' : 'flex')};
	}

	@media ${Breakpoints.mobile} {
		background: var(--white);
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	@media ${Breakpoints.mobile} {
		height: 100dvh;
		justify-content: flex-start;
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const FooterContainer = styled.div`
	width: 65rem !important;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		flex-wrap: wrap;
		width: 100% !important;

		> .footer-company-title {
			flex: 1 1 100%;
			text-align: center;
		}
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: center;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const MobileLogo = styled.div`
	display: none;
	position: absolute;
	top: 3rem;
	left: 3rem;

	@media ${Breakpoints.tablet} {
		display: block;
	}
`;

export const SlideContainer = styled.div`
	background: url('https://storage.googleapis.com/tryoto-public/referral/slider/bg.svg');
	position: relative;
	background-size: cover;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 6rem;
	width: 40%;
	min-height: 600px;

	@media ${Breakpoints.tablet} {
		width: 100%;
		padding: 3rem;
		display: ${(props) => (props.isSlideShow ? 'flex' : 'none')};
	}

	.swiper-container {
		display: inline-flex;
		width: 100%;

		.swiper-slide {
			box-sizing: border-box;
			padding: 1rem 1rem 5rem 1rem;
			gap: 5rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			> img {
				width: 60%;
				@media ${Breakpoints.tablet} {
					width: 90%;
				}
			}

			> div {
				display: flex;
				flex-direction: column;
				gap: 2rem;

				> .typography {
					&.title {
						font-size: 3.6rem;

						@media ${Breakpoints.tablet} {
							font-size: 2.8rem;
						}
					}
					&.subtitle {
						font-size: 2rem;
					}
				}
			}
		}

		.swiper-pagination-bullet {
			background: #98a9fa;

			&.swiper-pagination-bullet-active {
				background: #e3e6f6;
				border-radius: 2rem;
				width: 3rem;
			}
		}
	}
`;

export const MobileRegisterPageButton = styled(Button)`
	display: none;
	margin-top: 3rem;
	> .typography {
		font-size: 2rem;
	}

	@media ${Breakpoints.tablet} {
		display: flex;
	}
`;

export const MailLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	text-decoration: underline;
	color: var(--blue);
	:hover {
		> .typography,
		> .icon > svg {
			color: var(--blue);
		}
	}
`;
